<template>
  <v-app>
    <v-app-bar app color="white">
      <div class="d-flex">
        <v-img :src="logo" contain align="left" max-width="140" max-height="50"></v-img>
      </div>

      <v-spacer></v-spacer>

      <v-btn v-if="auth.token" v-on:click="logOut" color="secondary">Logout</v-btn>

      <dia-change-password v-if="auth.token"></dia-change-password>

      <v-btn href="https://bitbucket.org/beluca/auspac-ui" class="secondary--text" target="_blank" text>
        <span class="mr-2">v0.4.0</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>

      <v-btn icon color="secondary">
        <v-icon small>fa-info</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from 'vuex';
import diaChangePassword from '@/dialogs/diaChangePassword'

  export default {
    name: 'App',
    data() {
      return {
        logo: require('@/assets/logo.jpg')
      }
    },
    components: {
      diaChangePassword
    },
    methods: {
      logOut() {
        this.$store.dispatch('auth/writeToken', null)
        this.$router.push('/login')
      }
    },
    computed: {
      ...mapState('auth', ['auth']),
    }
  };
</script>